import type { ReactNode } from 'react';
import { Link, useLocation } from 'wouter';
import { useAuth } from '../auth.tsx';
import { ThemeToggle } from './ThemeToggle.tsx';

const NAV = [
  { href: '/search', label: 'Search', match: (l: string) => l.startsWith('/search') },
  { href: '/', label: 'Collection', match: (l: string) => l === '/' || l.startsWith('/locations') || l.startsWith('/cards') },
  { href: '/add', label: 'Add card', match: (l: string) => l.startsWith('/add') },
  { href: '/log', label: 'Log', match: (l: string) => l.startsWith('/log') },
  { href: '/settings', label: 'Settings', match: (l: string) => l.startsWith('/settings') },
];

export function Layout({ children }: { children: ReactNode }) {
  const [location] = useLocation();
  const { signOut } = useAuth();
  return (
    <>
      <header className="topbar">
        <Link href="/" className="brand">
          <img src="/icon.svg" alt="" width="26" height="26" />
          MTG Collection
        </Link>
        <nav className="nav" aria-label="Main">
          {NAV.map((n) => (
            <Link key={n.href} href={n.href} className={n.match(location) ? 'active' : ''} aria-current={n.match(location) ? 'page' : undefined}>
              {n.label}
            </Link>
          ))}
          <ThemeToggle />
          <button type="button" className="link" onClick={() => void signOut()}>
            Sign out
          </button>
        </nav>
      </header>
      <main className="main">{children}</main>
      <footer className="footer muted small">
        Card images, data and prices from <a href="https://scryfall.com">Scryfall</a>. Prices are TCGplayer USD. Version {__APP_VERSION__}.
      </footer>
    </>
  );
}

export function Centered({ children }: { children: ReactNode }) {
  return (
    <main className="centered">
      <h1 className="brand big">
        <img src="/icon.svg" alt="" width="34" height="34" />
        MTG Collection
      </h1>
      {children}
    </main>
  );
}
